import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import AboutSection from '@/components/AboutSection';
import MenuSection from '@/components/MenuSection';
import EventsSection from '@/components/EventsSection';
import EntertainmentSection from '@/components/EntertainmentSection';
import GallerySection from '@/components/GallerySection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import { SiteContentProvider } from '@/contexts/SiteContentContext';

export default function HomePage() {
  return (
    <SiteContentProvider>
      <div className="min-h-screen bg-[#141413]">
        <Navbar />
        <HeroSection />
        <div className="section-divider" />
        <AboutSection />
        <div className="section-divider" />
        <MenuSection />
        <div className="section-divider" />
        <EventsSection />
        <div className="section-divider" />
        <EntertainmentSection />
        <div className="section-divider" />
        <GallerySection />
        <div className="section-divider" />
        <ContactSection />
        <Footer />
      </div>
    </SiteContentProvider>
  );
}
